webpackJsonp([18,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(209);
	module.exports = __webpack_require__(208);


/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	var config = {
	  scheme: 'release',
	  env: {
	    alpha: {
	      prefix: ''
	    },
	    beta: {
	      prefix: '/admin',
	      apiPath: '/apiPath',
	      basicUrl: 'http://dev.lvyuetravel.com:8080',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.lvyuetravel.com:8080/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    devx: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://dev.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://dev.www.aihuazhu.com',
	      imagesUrl: 'http://dev.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    test: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://test.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://test.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    integrate: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://www.integrate.lvyuetravel.com',
	      aihuazhuUrl: 'http://www.integrate.aihuazhu.com',
	      imagesUrl: 'http://static.integrate.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://static.integrate.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    production: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'https://www.lvyuetravel.com',
	      aihuazhuUrl: 'https://www.aihuazhu.com',
	      imagesUrl: 'https://static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'https://static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=production'
	    }
	  },
	  domains: {
	    urlStatic: '',
	    loginSite: 'http://test.www.lvyuetravel.com'
	  }
	};
	
	// 环境切换
	if (false) {
	  config.scheme = 'beta';
	} else if (false) {
	  config.scheme = 'devx';
	} else if (false) {
	  config.scheme = 'test';
	} else if (false) {
	  config.scheme = 'integrate';
	} else if (true) {
	  config.scheme = 'production';
	}
	module.exports = config;

/***/ },

/***/ 2:
/***/ function(module, exports) {

	var language = 'zh-CN';
	if (window.location.search.indexOf('locale=USA') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=en') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=JP') > -1) {
	  language = 'JP';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=KO') > -1) {
	  language = 'KO';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=TH') > -1) {
	  language = 'TH';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=zh-CN') > -1) {
	  language = 'zh-CN';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=YH') > -1) {
	  language = 'YH';
	  localStorage.setItem('language', language);
	} else {
	  localStorage.setItem('language', language);
	}
	
	module.exports = { language: language };

/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	
	
	var config = __webpack_require__(1);
	config = config.env[config.scheme];
	// var xecond= config.env[config.scheme].senCond
	(function (para) {
	  //神策
	  var p = para.sdk_url,
	      n = para.name,
	      w = window,
	      d = document,
	      s = 'script',
	      x = null,
	      y = null;
	  w['sensorsDataAnalytic201505'] = n;
	  w[n] = w[n] || function (a) {
	    return function () {
	      (w[n]._q = w[n]._q || []).push([a, arguments]);
	    };
	  };
	  var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];
	  for (var i = 0; i < ifs.length; i++) {
	    w[n][ifs[i]] = w[n].call(null, ifs[i]);
	  }
	  if (!w[n]._t) {
	    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
	    x.async = 1;
	    x.src = p;
	    w[n].para = para;
	    y.parentNode.insertBefore(x, y);
	  }
	})({
	  sdk_url: config.senCondjs,
	  name: 'sensors',
	  server_url: config.senCond,
	  // server_url:' http://shence.lvyuetravel.com:8107',
	  cross_subdomain: true,
	  heatmap: {
	    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
	    clickmap: 'default',
	    //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
	    scroll_notice_map: 'not_collect'
	  }
	});
	sensors.registerPage({ platformType: 'pc' });
	sensors.quick('autoTrack'); //神策系统必须是1.4最新版及以上

/***/ },

/***/ 4:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 5:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 208:
/***/ function(module, exports, __webpack_require__) {

	// var languageType = require('./languageCommon.js')
	var language = localStorage.getItem('language') || 'zh-CN';
	// var s = require('./languageCommon')
	// console.log(s)
	var languageType = __webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(5);
	if (language == 'zh-CN') {
	    $('body').removeClass('en');
	} else {
	    $('body').addClass('en');
	}
	$('.commonflowerTravel').addClass('select');
	$('.reservation').css('color', 'white');
	var flagIndex = 0;
	var flag = 0;
	$('.reservationCode .close ,.reservationCode .guanbi').on('click', function () {
	    $('.reservationCode').fadeOut(300);
	    $('.reservation').css('opacity', 1);
	});
	
	$('.language').on('mouseover', function () {
	    $(".choicelanguage").show();
	}).on('mouseout', function () {
	    $(".choicelanguage").hide();
	});
	$('.choicelanguage a').eq(0).on('click', function () {
	    // debugger
	    console.log(window.location);
	    window.location.href = window.location.origin + window.location.pathname + '?locale=zh-CN';
	    localStorage.setItem('language', 'zh-CN');
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(1).on('click', function () {
	    localStorage.setItem('language', 'USA');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=USA';
	
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(2).on('click', function () {
	    localStorage.setItem('language', 'JP');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=JP';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(3).on('click', function () {
	    localStorage.setItem('language', 'KO');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=KO';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(4).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=TH';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(5).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=YH';
	    //window.location.reload();
	});
	$(".about1").on('mouseover', function () {
	    $(".aboutLv").show();
	});
	$(".about1").on('mouseout', function () {
	    $(".aboutLv").hide();
	});
	$(".brand1").on('mouseover', function () {
	    $(".choiceBrand").show();
	}).on('mouseout', function () {
	    $(".choiceBrand").hide();
	});
	
	var width = 198;
	
	var width1 = $('.floralTrip_container_header').width();
	flagIndex = width1 - width;
	
	$('.floralTrip_container_header_conainer div').css({ width: width });
	$('.floralTrip_container_header_conainer').css({ width: 7 * width });
	$(window).resize(function () {
	    //当浏览器大小变化时
	    width1 = $('.floralTrip_container_header').width();
	    flagIndex = width1 - width;
	});
	var step = 1;
	var $headerContainer = $('.floralTrip_container_header_conainer');
	var timer = setInterval(move, 3000);
	var moveflag = 0;
	moveflag = -flagIndex / 2;
	$headerContainer.css({ 'left': -width - moveflag });
	function move(n) {
	    moveflag = -flagIndex / 2;
	    step++;
	    n != undefined ? step = n : null;
	    if (step == 5) {
	        $headerContainer.css('left', -width - moveflag);
	        step = 2;
	    }
	    $('.floralTrip_banner li').eq(step - 1).addClass('floralTrip_banner_select').siblings().removeClass('floralTrip_banner_select');
	    if (step == 4) {
	        $('.floralTrip_banner li').eq(0).addClass('floralTrip_banner_select').siblings().removeClass('floralTrip_banner_select');
	    }
	    $headerContainer.stop(false, true).animate({ left: -step * width - moveflag }, 500, 'linear', function () {});
	}
	$('.floralTrip_container_header').on('mouseover', function () {
	    clearInterval(timer);
	});
	$('.floralTrip_container_header').on('mouseout', function () {
	    timer = setInterval(move, 3500);
	});
	$('.floralTrip_banner li').on('click', function () {
	    step = $('.floralTrip_banner li').index($(this)) + 1;
	    $('.floralTrip_banner li').eq(step - 1).addClass('floralTrip_banner_select').siblings().removeClass('floralTrip_banner_select');
	    $headerContainer.stop(false, true).css({ left: -step * width + -moveflag });
	});

/***/ },

/***/ 209:
/***/ function(module, exports, __webpack_require__) {

	// var languageType = require('./languageCommon.js')
	var languageType = __webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	
	if (language == 'zh-CN') {
	    document.getElementsByTagName('meta')[1].setAttribute('content', floralTripmeta[language]);
	    document.getElementsByTagName('meta')[2].setAttribute('content', floralTripkey[language]);
	    document.title = floralTripTitle[language];
	} else {
	    document.getElementsByTagName('meta')[1].setAttribute('content', floralTripmeta['USA']);
	    document.getElementsByTagName('meta')[2].setAttribute('content', floralTripkey['USA']);
	    document.title = floralTripTitle['USA'];
	    // document.getElementsByTagName('title')[1].setAttribute('content',grouptitle['USA'])
	}
	$('.commonlanguage').html(commonlanguage[language]);
	$('.commonHomePage').html(commonHomePage[language]);
	$('.commonLvyue').html(commonLvyue[language]);
	$('.commonAboutLvyue').html(commonAboutLvyue[language]);
	$('.commonlvyueBrand').html(commonlvyueBrand[language]);
	$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
	$('.commonFloralLux').html(commonFloralLux[language]);
	$('.commonClaim').html(commonClaim[language]);
	$('.commonWeiLai').html(commonWeiLai[language]);
	$('.commonTanChen').html(commonTanChen[language]);
	$('.commonflowerTravel').html(commonflowerTravel[language]);
	$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
	$('.commonPanorama').html(commonPanorama[language]);
	// $('.commonPaidInformation').html(commonPaidInformation[language]);
	$('.commonZh').html(commonZh[language]);
	$('.commonUsa').html(commonUsa[language]);
	$('.commonJp').html(commonJp[language]);
	$('.commonKo').html(commonKo[language]);
	$('.commonTh').html(commonTh[language]);
	$('.commonYh').html(commonYh[language]);
	$('.commonReservations a').html(commonReservations[language]);
	$('.commonClose').html(commonClose[language]);
	$('.commonFreebooking').html(commonFreebooking[language]);
	$('.commonDownload').html(commonDownload[language]);
	$('.commonWechatSubscription').html(commonWechatSubscription[language]);
	$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
	$('.commonBrandintroductio').html(commonBrandintroductio[language]);
	$('.commonWantJoin').html(commonWantJoin[language]);
	$('.commonConectUs').html(commonConectUs[language]);
	$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
	$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
	$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
	$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
	$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
	$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
	$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
	$('.commonCompanyInfo').html(commonCompanyInfo[language]);
	$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
	$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
	$('.commonCompanyLicense').html(commonCompanyLicense[language]);
	$('.commonCompanyICP').html(commonCompanyICP[language]);
	$('.teamLeaderName1').html(teamLeaderName1[language]);
	$('.teamLeaderName2').html(teamLeaderName2[language]);
	$('.teamLeaderName3').html(teamLeaderName3[language]);
	$('.teamLeaderZhiwei1').html(teamLeaderZhiwei1[language]);
	$('.teamLeaderZhiwei2').html(teamLeaderZhiwei2[language]);
	$('.teamLeaderZhiwei3').html(teamLeaderZhiwei3[language]);
	$('.commonLvyue1').html(commonLvyue1[language]);
	$('.Leadership').html(Leadership[language]);
	$('.LeadershipIntro').html(LeadershipIntro[language]);
	$('.teamLeaderDesc1').html(teamLeaderDesc1[language]);
	$('.teamLeaderDesc2').html(teamLeaderDesc2[language]);
	$('.teamLeader1').html(teamLeader1[language]);
	$('.teamLeader2').html(teamLeader2[language]);
	$('title').html(floralTripTitle1[language]);
	$('.TalentRecruitment').html(TalentRecruitment[language]);
	$('.floralTrip_info p').html(floralAPPIntro[language]);
	$('.floralTrip_info h3').html(floralAPPMaxim[language]);
	$('.floralTrip_functions_title').html(floralFuncTitle[language]);
	$('.floralTrip_functions .fun1 p').html(floralReservation[language]);
	$('.floralTrip_functions .fun1 .span1').html(floralReservationDetail1[language]);
	$('.floralTrip_functions .fun1 .span2').html(floralReservationDetail2[language]);
	$('.floralTrip_functions .fun2 p').html(floralMembership[language]);
	$('.floralTrip_functions .fun2 .span1').html(floralMembershipDetail1[language]);
	$('.floralTrip_functions .fun2 .span2').html(floralMembershipDetail2[language]);
	$('.floralTrip_functions .fun2 .span3').html(floralMembershipDetail3[language]);
	$('.floralTrip_functions .fun3 p').html(floralGuides[language]);
	$('.floralTrip_functions .fun3 .span1').html(floralGuidesDetail1[language]);
	$('.floralTrip_functions .fun4 p').html(floralCommunity[language]);
	$('.floralTrip_functions .fun4 .span1').html(floralCommunityDetail1[language]);
	$('.floralTrip_functions .fun4 .span2').html(floralCommunityDetail2[language]);
	$('.floralTrip_functions .fun4 .span3').html(floralCommunityDetail3[language]);
	$('.floralTrip_functions .fun4 .span4').html(floralCommunityDetail4[language]);
	$('.floralTrip_functions .fun5 p').html(floralEvents[language]);
	$('.floralTrip_functions .fun5 .span1').html(floralEventsDetail1[language]);
	$('.floralTrip_functions .fun5 .span2').html(floralEventsDetail2[language]);
	$('.floralTrip_functions .fun5 .span3').html(floralEventsDetail3[language]);
	$('.floralTrip_functions .fun6 p').html(floralTickets[language]);
	$('.floralTrip_functions .fun6 .span1').html(floralTicketsDetail1[language]);
	$('.floralTrip_functions .fun6 .span2').html(floralTicketsDetail2[language]);
	$('.floralTrip_functions .fun6 .span3').html(floralTicketsDetail3[language]);
	$('.floralReservation').html(floralReservation[language]);
	$('.commonBaina').html(commonBaina[language]);
	$('.commonBanlan').html(commonBanlan[language]);

/***/ }

});


/** WEBPACK FOOTER **
 ** js/floralTrip.94cf8b3f.js
 **/